/**
 * Custom Cascade Icon Component
 * Uses the same SVG design as the favicon
 */

import { SvgIcon, SvgIconProps } from '@mui/material';

const CascadeIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 100 100">
      <defs>
        <linearGradient id="waveGradient" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" style={{ stopColor: '#1976d2', stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: '#0d47a1', stopOpacity: 1 }} />
        </linearGradient>
      </defs>
      
      {/* Background circle */}
      <circle cx="50" cy="50" r="48" fill="url(#waveGradient)"/>
      
      {/* Cascade waves icon */}
      <g fill="white" opacity="0.9">
        {/* Top wave */}
        <path d="M 25 30 Q 35 25, 45 30 T 65 30 T 85 30" stroke="white" strokeWidth="3" fill="none" strokeLinecap="round"/>
        
        {/* Middle wave */}
        <path d="M 20 45 Q 30 40, 40 45 T 60 45 T 80 45" stroke="white" strokeWidth="3.5" fill="none" strokeLinecap="round"/>
        
        {/* Bottom wave */}
        <path d="M 15 60 Q 25 55, 35 60 T 55 60 T 75 60" stroke="white" strokeWidth="4" fill="none" strokeLinecap="round"/>
        
        {/* Droplets */}
        <circle cx="30" cy="70" r="2.5" fill="white"/>
        <circle cx="50" cy="73" r="2" fill="white"/>
        <circle cx="70" cy="71" r="2.5" fill="white"/>
      </g>
    </SvgIcon>
  );
};

export default CascadeIcon;

